import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store, {
  setValueAtPath,
  listenToPath,
} from "nexia_mobile/flux_like/store";
import LocalSettings from "nexia_mobile/models/local_settings";
import { showNewsDialog } from "nexia_mobile/components/Dialogs/NewsDialog";
import Environment from "nexia_mobile/environment";

listenToPath("newsDialogOpen", (newValue, oldValue) => {
  if (newValue && !oldValue) {
    showNewsDialog({
      collection: Store.session.get("news"),
      onCloseDialog: () => setValueAtPath("newsDialogOpen", false),
    });
  }
});

Dispatch.on("SHOW_NEWS", () => {
  setValueAtPath("newsDialogOpen", !Environment.isCommercial());
});

Dispatch.on("SHOW_NEWS_FROM_STARTUP", () => {
  if (!Store.session) {
    return;
  }
  if (Store.appState == null) {
    return;
  }
  if (!Store.session.hasUnreadNews()) {
    return;
  }
  if (!LocalSettings.getShowNews()) {
    return;
  }

  Dispatch("SHOW_NEWS");
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/news.js